<template>
  <div class="main-wrapper">
    <p>
      <span
        :class="NO_FATCA[0] || NO_FATCA[1] ? 'valid-field' : 'unvalid-field'"
        >➤</span
      >
      Принадлежность организации к финансовому институту для целей FATCA (для
      определения принадлежности к данному критерию обратитесь к информации на
      сайте
      <a href="https://www.irs.gov/">www.irs.gov</a>)
    </p>
    <div class="checkboxes">
      <label>
        <input
          class="necessary-bold"
          type="checkbox"
          v-model="NO_FATCA[1]"
          @click="
            NO_FATCA = [false, NO_FATCA[1]];
            anotherGIIN = '';
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('NO_FATCA') != -1
          "
        />
        Организация НЕ является финансовым институтом для целей FATCA
      </label>
      <label>
        <input
          class="necessary-bold"
          type="checkbox"
          v-model="NO_FATCA[0]"
          @click="
            NO_FATCA = [NO_FATCA[0], false];
            anotherGIIN = '';
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('NO_FATCA') != -1
          "
        />
        Организация является финансовым институтом для целей FATCA
      </label>
    </div>

    <div v-if="NO_FATCA[0]" class="input-GIIN">
      Укажите GIIN или статус, при котором GIIN не присваивается:
      <input type="text" v-model="anotherGIIN" />
    </div>

    <p>
      <span
        :class="
          NO_US_RESIDENT[0] || NO_US_RESIDENT[1]
            ? 'valid-field'
            : 'unvalid-field'
        "
        >➤</span
      >
      Принадлежность организации к статусу американского налогового резидента
      для целей FATCA (американским налоговым резидентом юридического лица
      является лицо, кроме лиц, исключенных для целей FATCA, которое имеет один
      или несколько из следующих признаков: страна регистрации или налогового
      резидентства юридического лица является США; адрес местонахождения или
      почтовый адрес находится в США; пассивная нефинансовая организация
      зарегистрирована/учреждена не на территории США, более 10% долей в
      уставном капитале (акций, доходов в товариществе, бенефициарного интереса)
      которой принадлежит налоговым резидентам США (персоне США и/или
      «американскому» юридическому лицу); наличие постоянного поручения о
      регулярном переводе средств на счета, открытые в финансовых институтах,
      расположенных в США). Более подробную информацию определения
      принадлежности к данным признакам можно узнать на сайте
      <a href="https://www.irs.gov/"></a> www.irs.gov.
    </p>
    <div class="checkboxes">
      <label>
        <input
          type="checkbox"
          class="necessary-bold"
          v-model="NO_US_RESIDENT[1]"
          @click="NO_US_RESIDENT = [false, NO_US_RESIDENT[1]]"
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('NO_US_RESIDENT') != -1
          "
        />
        Организация НЕ имеет признаки налогового резидента США
      </label>
      <label>
        <input
          type="checkbox"
          class="necessary-bold"
          v-model="NO_US_RESIDENT[0]"
          @click="NO_US_RESIDENT = [NO_US_RESIDENT[0], false]"
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('NO_US_RESIDENT') != -1
          "
        />
        Организация имеет признаки налогового резидента США
      </label>
    </div>
    <p>
      <span :class="AGREE_FATCA_INCASSO ? 'valid-field' : 'unvalid-field'"
        >➤</span
      >
      Организация подтверждает правильность и правдивость указанной выше
      информации и предупреждена о последствиях искажения этой информации. В
      случае предоставления недостоверной информации, выражает, подписанием
      настоящего опросного листа, заранее данный акцепт на оплату платежных
      требований {{ bankName }}, предъявляемых к банковским счетам (счетам по
      вкладу), открытым в {{ bankName }}, либо на оплату инкассовых поручений
      {{ bankName }}, для взыскания денежных средств, подлежащих уплате в
      соответствии с положениями FATCA, либо возмещению денежных средств,
      взысканных с {{ bankName }} на основании FATCA. В случаях предусмотренных
      Федеральном законом от 28.06.2014 № 173-ФЗ {{ bankName }} вправе принять
      решение об отказе от совершения операций и(или) расторгнуть в
      одностороннем порядке договор или отказать в заключение договора:
    </p>
    <label>
      <input
        type="checkbox"
        class="necessary-bold"
        v-model="AGREE_FATCA_INCASSO"
        :disabled="
          pageInfo.DISABLED != null &&
            pageInfo.DISABLED.indexOf('AGREE_FATCA_INCASSO') != -1
        "
      />
      ДА
    </label>
    <p>
      <span
        :class="
          NO_FOREIGN_SIGNS_RESIDENT_DD[0] ||
          NO_FOREIGN_SIGNS_RESIDENT_DD[1] ||
          NO_FOREIGN_SIGNS_RESIDENT_DD[2]
            ? 'valid-field'
            : 'unvalid-field'
        "
        >➤</span
      >
      Принадлежность организации к статусу иностранного налогового резидента
      (кроме США) (юридическое лицо, которое имеет один или несколько из
      следующих признаков: место инкорпорации (учреждения) является иностранное
      государство; адрес (в том числе адрес головного офиса, адрес органа
      управления или управляющей структуры) находится в иностранном государстве;
      юридическое лицо относится к пассивной нефинансовой организации, у которой
      более 25% прямого или косвенного владения капиталом или влияния
      принадлежит физическим лицам налоговым резидентам иностранного
      государства). <br />Более подробную информацию можно узнать на портале
      ОЭСР по автоматическому обмену информацией и/или на сайт налог.ру по
      адресу
      <a
        href="https://340fzreport.nalog.ru/html/sites/www.340fzreport.nalog.ru/doc/a_obmen_info_v092020.pdf"
        target="_blank"
        >https://340fzreport.nalog.ru/html/sites/www.340fzreport.nalog.ru/doc/a_obmen_info_v092020.pdf</a
      >)
    </p>
    <div class="checkboxes">
      <label>
        <input
          type="checkbox"
          class="necessary-bold"
          v-model="NO_FOREIGN_SIGNS_RESIDENT_DD[0]"
          @click="
            NO_FOREIGN_SIGNS_RESIDENT_DD = [
              NO_FOREIGN_SIGNS_RESIDENT_DD[0],
              false,
              false,
            ]
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('NO_FOREIGN_SIGNS_RESIDENT_DD') != -1
          "
        />
        Организация НЕ имеет признаков налогового резидента иностранного
        государства/территории и является налоговым резидентом только Российской
        Федерации
      </label>
      <label>
        <input
          type="checkbox"
          class="necessary-bold"
          v-model="NO_FOREIGN_SIGNS_RESIDENT_DD[1]"
          @click="
            NO_FOREIGN_SIGNS_RESIDENT_DD = [
              false,
              NO_FOREIGN_SIGNS_RESIDENT_DD[1],
              false,
            ]
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('NO_FOREIGN_SIGNS_RESIDENT_DD') != -1
          "
        />
        Организация имеет признаки налогового резидента иностранного
        государства/территории
      </label>
      <label>
        <input
          type="checkbox"
          class="necessary-bold"
          v-model="NO_FOREIGN_SIGNS_RESIDENT_DD[2]"
          @click="
            NO_FOREIGN_SIGNS_RESIDENT_DD = [
              false,
              false,
              NO_FOREIGN_SIGNS_RESIDENT_DD[2],
            ]
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('NO_FOREIGN_SIGNS_RESIDENT_DD') != -1
          "
        />
        Организация НЕ имеет признаков налогового резидента ни одного
        государства (территории)
      </label>
    </div>
    <p>
      <span
        :class="
          NO_FOREIGN_SIGNS_RESIDENT_AGREE ? 'valid-field' : 'unvalid-field'
        "
        >➤</span
      >
      Организация подтверждает правильность и правдивость указанной выше
      информации и предупреждена о последствиях искажения этой информации. В
      случаях, предусмотренных Налоговым кодексом Российской Федерации ПАО
      «РосДорБанк» вправе принять решение об отказе от совершения операций,
      осуществляемых в пользу или по поручению клиента по договору,
      предусматривающему оказание финансовых услуг и(или) расторгнуть в
      одностороннем порядке договор, предусматривающий оказание финансовых услуг
      или отказать в заключении договора, предусматривающего оказание финансовых
      услуг.
    </p>
    <label>
      <input
        type="checkbox"
        class="necessary-bold"
        v-model="NO_FOREIGN_SIGNS_RESIDENT_AGREE"
        :disabled="
          pageInfo.DISABLED != null &&
            pageInfo.DISABLED.indexOf('NO_FOREIGN_SIGNS_RESIDENT_AGREE') != -1
        "
      />
      Да
    </label>
  </div>
</template>

<script>
export default {
  name: "FatcaAgreement",
  props: {
    pageInfo: {},
    pageName: String,
    bankName: String,
  },
  data: () => ({
    NO_FATCA: [false, false],
    NO_US_RESIDENT: [false, false],
    NO_FOREIGN_SIGNS_RESIDENT_DD: [false, false, false],
    AGREE_FATCA_INCASSO: false,
    NO_FOREIGN_SIGNS_RESIDENT_AGREE: false,
    anotherGIIN: "",
    sendData: {},
  }),
  methods: {
    validation() {
      var msg = "";
      if (!(this.NO_FATCA[0] || this.NO_FATCA[1]))
        msg +=
          "Необходимо заполнить поля:<br>• Принадлежность юридического лица к финансовому институту для целей FATCA<br>";
      if (this.NO_FATCA[0] && this.anotherGIIN.length == 0)
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Укажите GIIN или статус, при котором GIIN не присваивается<br>"
            : "• Укажите GIIN или статус, при котором GIIN не присваивается<br>";
      if (!(this.NO_US_RESIDENT[0] || this.NO_US_RESIDENT[1]))
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Принадлежность юридического лица к статусу американского налогового резидента<br>"
            : "• Принадлежность юридического лица к статусу американского налогового резидента<br>";
      if (
        !(
          this.NO_FOREIGN_SIGNS_RESIDENT_DD[0] ||
          this.NO_FOREIGN_SIGNS_RESIDENT_DD[1] ||
          this.NO_FOREIGN_SIGNS_RESIDENT_DD[2]
        )
      )
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• Принадлежность юридического лица к статусу иностранного налогового резидента (кроме США)<br>"
            : "• Принадлежность юридического лица к статусу иностранного налогового резидента (кроме США)<br>";
      if (!this.AGREE_FATCA_INCASSO)
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• 1 - Организация подтверждает правильность и правдивость указанной выше информации<br>"
            : "• 1 - Организация подтверждает правильность и правдивость указанной выше информации<br>";
      if (!this.NO_FOREIGN_SIGNS_RESIDENT_AGREE)
        msg +=
          msg.length == 0
            ? "Необходимо заполнить поля:<br>• 2 - Организация подтверждает правильность и правдивость указанной выше информации<br>"
            : "• 2 - Организация подтверждает правильность и правдивость указанной выше информации<br>";

      this.$emit("enableButtons", true, msg);
      if (msg.length == 0) {
        if (this.NO_FATCA[0]) this.sendData.ANOTHER_GIIN = this.anotherGIIN;
        this.sendData.NO_FATCA = this.NO_FATCA[0];
        this.sendData.NO_US_RESIDENT = this.NO_US_RESIDENT[0];
        this.sendData.AGREE_FATCA_INCASSO = this.AGREE_FATCA_INCASSO;
        this.sendData.NO_FOREIGN_SIGNS_RESIDENT_AGREE = this.NO_FOREIGN_SIGNS_RESIDENT_AGREE;
        if (this.NO_FOREIGN_SIGNS_RESIDENT_DD[0])
          this.sendData.NO_FOREIGN_SIGNS_RESIDENT_DD = 0;
        else if (this.NO_FOREIGN_SIGNS_RESIDENT_DD[1])
          this.sendData.NO_FOREIGN_SIGNS_RESIDENT_DD = 1;
        else if (this.NO_FOREIGN_SIGNS_RESIDENT_DD[2])
          this.sendData.NO_FOREIGN_SIGNS_RESIDENT_DD = -1;
        this.$emit("changePageSendData", this.sendData, false);
      }
    },
  },
  async created() {
    try {
      this.sendData.INN = this.pageInfo.INN;

      this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
      this.sendData.ID = this.pageInfo.ID;
      if (this.pageInfo.NO_FATCA != null)
        this.NO_FATCA = [this.pageInfo.NO_FATCA, !this.pageInfo.NO_FATCA];
      if (this.pageInfo.ANOTHER_GIIN != null)
        this.anotherGIIN = this.pageInfo.ANOTHER_GIIN;
      if (this.pageInfo.NO_US_RESIDENT != null)
        this.NO_US_RESIDENT = [
          this.pageInfo.NO_US_RESIDENT,
          !this.pageInfo.NO_US_RESIDENT,
        ];
      if (this.pageInfo.NO_FOREIGN_SIGNS_RESIDENT_AGREE)
        this.NO_FOREIGN_SIGNS_RESIDENT_AGREE = true;
      if (this.pageInfo.NO_FOREIGN_SIGNS_RESIDENT_DD != null)
        switch (this.pageInfo.NO_FOREIGN_SIGNS_RESIDENT_DD) {
          case 1:
            this.NO_FOREIGN_SIGNS_RESIDENT_DD[1] = true;
            break;
          case 0:
            this.NO_FOREIGN_SIGNS_RESIDENT_DD[0] = true;
            break;
          case -1:
            this.NO_FOREIGN_SIGNS_RESIDENT_DD[2] = true;
            break;
        }
      if (
        this.pageInfo.AGREE_FATCA_INCASSO != null &&
        !this.AGREE_FATCA_INCASSO
      )
        this.AGREE_FATCA_INCASSO = this.pageInfo.AGREE_FATCA_INCASSO;
    } catch (error) {
      console.log(error);
    }
    this.validation();
  },
  updated() {
    this.validation();
    this.$emit("updated");
  },
};
</script>

<style scoped>
.main-wrapper {
  text-align: justify;
}
.necessary {
  color: red;
}
input[type="text"] {
  border: none;
  border-bottom: 1px solid #cccccc;
  width: 50%;
  margin-left: 10px;
}
input[type="text"]:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
.checkboxes {
  display: flex;
  flex-direction: column;
}
.input-GIIN {
  padding-top: 10px;
  display: flex;
  flex-direction: row;
}
</style>
